export function PageHero({ eyebrow, title, text, image, testid, children }) {
  return (
    <section className="relative overflow-hidden border-b border-white/10" data-testid={testid}>
      {image && <img src={image} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-40" />}
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
      <div className="relative mx-auto max-w-7xl px-6 py-20 md:py-28">
        <div className="max-w-2xl reveal">
          <div className="overline text-volt mb-5">{eyebrow}</div>
          <h1 className="font-head font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight uppercase">{title}</h1>
          {text && <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-xl tracking-wide">{text}</p>}
          {children}
        </div>
      </div>
    </section>
  );
}
